const AboutUdemandmeCom = () => {
  return (
    <>
      <section className="contact py-80">
        <div className="container container-lg">
          <div className="row gy-5">
            <div className="col-lg-6">
              <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                <h4 className="px-60 text-bold headingsize ">
                  About <span className="primecolor">Udemandme</span>
                </h4>

                <ul className="mt-32">
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                      <i className="ph ph-check text-danger" />
                    </span>
                    <span className="text-md text-gray-900 ">
                      UdemandMe is a UAE-based e-commerce platform designed for
                      the modern shopper, combining convenience, speed, and
                      reliability. We offer a comprehensive range of
                      products—from industrial tools and building materials to
                      machinery and electrical supplies—all available through
                      one trusted online destination.
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                      <i className="ph ph-check text-danger" />
                    </span>
                    <span className="text-md text-gray-900 ">
                      UdemandMe is a UAE-based e-commerce platform created to
                      make sourcing industrial tools, building materials, and
                      electrical supplies faster, easier, and more reliable than
                      ever before. Designed for modern shoppers and businesses
                      alike, we combine convenience, speed, and trust to deliver
                      an exceptional online purchasing experience.
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                      <i className="ph ph-check text-danger" />
                    </span>
                    <span className="text-md text-gray-900 ">
                      Whether you’re a contractor searching for high-quality
                      building materials, a technician in need of reliable
                      electrical components, or a business looking to streamline
                      procurement, UdemandMe brings everything you need together
                      in one place. Our growing product catalog features trusted
                      brands and verified suppliers, ensuring that every
                      purchase meets the highest standards of quality and
                      performance.
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-two-600 text-2xl flex-shrink-0">
                      <i className="ph ph-check text-danger" />
                    </span>
                    <span className="text-md text-gray-900 ">
                      At UdemandMe, we’re more than just an online store — we’re
                      your dependable partner for all things industrial, helping
                      customers across the UAE save time, reduce hassle, and get
                      the products they need when they need them.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <img loading="lazy"
                src="assets/images/about/about-udemandme.png"
                alt=""
                className="cover-img rounded-16 about"
              />
            </div>
          </div>
        </div>
        <div className="container container-lg pt-60">
          <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
            <div className="row gy-5">
              <div className="col-lg-6 px-20">
                <h6 className="mb-24">Credit Facility</h6>
                <ul className="mt-32">
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="text-md text-gray-900 ">
                      Register yourself as a creditor at udemandme.com and enjoy
                      multiple benefits (subject to fulfilling the requirements
                      and approval of documents by the management of
                      udemandme.com)
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="text-md text-gray-900 ">
                      Credit facility is provided for a specific amount and
                      credit period.
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="text-md text-gray-900 ">
                      Credit facility for individuals is also available, subject
                      to a maximum limit of AED 2,000 and a maximum period of 30
                      days (after approval by management).
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="text-md text-gray-900 ">
                      Discounts are available from time to time.
                    </span>
                  </li>
                  <li className="text-gray-400 mb-14 flex-align gap-14">
                    <span className="text-md text-gray-900 ">
                      We offer the best shipping rates.
                    </span>
                  </li>
                </ul>
                <div>
                  <div>
                    <h6 className="mb-24 mt-24">Search Bar</h6>
                    <ul className="mt-32">
                      <li className="text-gray-400 mb-14 flex-align gap-14">
                        <span className="text-md text-gray-900 ">
                          Purchase directly through the search bar.
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14">
                        <span className="text-md text-gray-900 ">
                          Delivery is available worldwide, subject to government
                          restrictions.
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14">
                        <span className="text-md text-gray-900 ">
                          Customs duties and shipping charges for deliveries
                          outside the UAE can be discussed, and the best rates
                          and delivery schedule will be provided.
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14">
                        <span className="text-md text-gray-900 ">
                          Your suggestions are welcome, and we are committed to
                          providing our best services.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 px-20">
                <div>
                  <h6 className="mb-24 ">Payment System</h6>
                  <ul className="mt-32">
                    <li className="text-gray-400 mb-14 flex-align gap-14">
                      <span className="text-md text-gray-900 ">
                        Udemandme has designed its payment system for customer
                        convenience, offering multiple options such as
                      </span>
                    </li>
                    <ul className="mt-32">
                      <li className="text-gray-400 mb-14 flex-align gap-14 px-20">
                        <span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Cash
                          <span className="text-gray-500"> </span>
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14 px-20">
                        <span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Credit Card
                          <span className="text-gray-500"></span>
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14 px-20">
                        <span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Debit Card
                          <span className="text-gray-500"> </span>
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14 px-20">
                        <span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Net Banking
                          <span className="text-gray-500"> </span>
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14 px-20">
                        <span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Card Swiping
                          <span className="text-gray-500"> </span>
                        </span>
                      </li>
                      <li className="text-gray-400 mb-14 flex-align gap-14 px-20">
                        <span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
                          <i className="ph ph-check"></i>
                        </span>
                        <span className="text-heading fw-medium">
                          Digital Wallets
                          <span className="text-gray-500"> </span>
                        </span>
                      </li>
                    </ul>
                    <li className="text-gray-400 mb-14 flex-align gap-14 pt-5">
                      <span className="text-md text-gray-900 ">
                        Normal delivery will be made within 24 working hours. In
                        case of any delay, it will be communicated to the client
                        within 12 working hours.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutUdemandmeCom;
